import React from "react"
import ErrorBoundary from "@components/error_boundaries/"
import Messages from "@components/messages"
import DownloadLink from "./link"

class DownloadLinkWrap extends React.Component {
  render() {
    return (
      <div>
        <ErrorBoundary>
          <DownloadLink {...this.props}/>
        </ErrorBoundary>
        <Messages/>
      </div>
    )
  }
}

export default DownloadLinkWrap
